import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import qs from "../node_modules/qs/lib/index"; // 按需导入qs模块:post请求用到
const predict = {
  /**
   * 查询电量预测
   * @param {*} measureId 测量点id
   * @param {*} startTime 开始时间
   * @param {*} endTime 结束时间
   * @param {*} type 时间类型
   */
  puzzlePredictedQuantityByHour (measures, startTime, endTime, type) {
    let params = {
      measures: JSON.stringify(measures),
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
      type: type

    };
    return axios.post(base.predict.puzzlePredictedQuantityByHour, qs.stringify(params));
  },
  /**
   * 查询需量预测
   * @param {*} measureId 测量点id
   * @param {*} startTime 开始时间
   * @param {*} endTime 结束时间
   * @param {*} type 时间类型
   */
  puzzlePredictQuantityRequiredByHour (measures, startTime, endTime, type) {
    let params = {
      measures: JSON.stringify(measures),
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
      type: type
    };
    return axios.post(base.predict.puzzlePredictQuantityRequiredByHour, qs.stringify(params));
  },
  /**
   * 查询变压器负载率
   * @param {*} measures 测量点id
   * @param {*} startTime 开始时间
   * @param {*} endTime 结束时间
   */
  puzzleLoadFactorAreaCountStatics (measuresIds, startTime, endTime) {
    let params = {
      measuresIds: JSON.stringify(measuresIds),
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime.replace(/-/g, "/"),
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime.replace(/-/g, "/")
    };
    return axios.post(base.predict.puzzleLoadFactorAreaCountStatics, qs.stringify(params));
  },
};

export default predict;